import { render, staticRenderFns } from "./MerchProducts.vue?vue&type=template&id=5121f218&scoped=true"
import script from "./MerchProducts.vue?vue&type=script&lang=js"
export * from "./MerchProducts.vue?vue&type=script&lang=js"
import style0 from "./MerchProducts.vue?vue&type=style&index=0&id=5121f218&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5121f218",
  null
  
)

export default component.exports